import React from 'react'

import { Image } from 'antd'
import dayjs from 'dayjs'
import Cookies from 'js-cookie'

import { Personal } from '@/components/Personal'
import { Books } from '@/components/Waterfall/Items/Books'
import { Discuss, IConfig } from '@/components/Waterfall/Items/Discuss'
import { Story } from '@/components/Waterfall/Items/Story'
import { VideoItem } from '@/components/Waterfall/Items/VideoItem'
import { useCustomNavigate } from '@/hooks/useCustomNavigate'
import {
  IMessageContentExtra,
  ISessionHistoryItem
} from '@/httpRequest/modules/mesperyIm/sessionHistory'
import { IStoryListItem } from '@/httpRequest/modules/novel/list'
import { IListRellItem } from '@/httpRequest/modules/user/listReel'
import { EPublishType } from '@/pages/Home/Types'
import { useMessageAtom } from '@/pages/MesperyIM/store/message'
import { MessageEnum } from '@/pages/MesperyIM/Types'
import { getGlobalConfig } from '@/utils'

import styles from '../message.module.less'

export enum ENotificationType {
  GO_TO_SIGN = 1,
  CHECK_IT = 2
}

export interface IMessageContentNewExtra {
  content: string
  extra: {
    button: Array<{
      text: string
      link: string
      link_mobile?: string
      link_android?: string
      link_ios?: string
      link_creating?: string
    }>
    popup?: {
      style: number
      postion: number
      auto_close: boolean
      display_time: number
    }
  }
}

interface Props {
  type: string
  self: boolean
  data?: ISessionHistoryItem
  config?: IConfig
  extra?: unknown
  userData?: {
    nickname?: string
    avatar?: string
  }
  showTime?: boolean
}

const MessageFilterJumpURL = [
  '/personal/review',
  '/personal/publish',
  '/personal/collection'
]

const CREATE_URL = getGlobalConfig().VITE_WRITING_STATION_URL

export const MessageItem: React.FC<Props> = (props) => {
  const { type, self, data, config, extra, userData = {}, showTime } = props
  const { nickname } = userData

  const { customNavigator } = useCustomNavigate()
  const { toggleMessageModalVisible } = useMessageAtom()

  const blackBgMsg = [MessageEnum.Text, MessageEnum.Reply]

  const contentData =
    typeof data?.message_content === 'string'
      ? data?.message_content
      : data?.message_content.content

  // 新系统消息内容相关
  const isNewSystemMsg = type === MessageEnum.NewSystemMsg
  const newSystemMsgContentData = isNewSystemMsg
    ? typeof data?.message_content === 'string'
      ? (JSON.parse(data.message_content) as unknown as IMessageContentNewExtra)
      : (data?.message_content as unknown as IMessageContentNewExtra)
    : undefined

  const handleRead = () => {
    const sourceInfo = extra as Record<string, string>
    if (!sourceInfo) return
    toggleMessageModalVisible(false)
    if (type === MessageEnum.Books) {
      customNavigator(
        `/detail/book/${EPublishType.Lists}-${sourceInfo.resourceId}`
      )
      return
    }

    if (type === MessageEnum.Discuss) {
      customNavigator(
        `/detail/discuss/${EPublishType.Community}-${sourceInfo.resourceId}`
      )
      return
    }
    customNavigator(`/cover/${sourceInfo.sourceType}-${sourceInfo.resourceId}`)
  }

  const handleShowJumpLinkBtn = (
    button: IMessageContentNewExtra['extra']['button'][0]
  ) => {
    return (
      button?.link && !MessageFilterJumpURL.includes(button?.link.split('?')[0])
    )
  }

  const handleJumpTo = (link: string) => {
    if (!link) return

    const targetLink = link

    if (targetLink.includes(CREATE_URL)) {
      // 作者站 站内跳转
      const token = localStorage.getItem('token') || ''
      const tokenExpire = localStorage.getItem('tokenExpire')
      // 设置 token 到 cookie
      Cookies.set('token', token, {
        expires: new Date(Number(tokenExpire) * 1000),
        domain: '.mespery.com'
      })
      window.location.href = targetLink
      return
    }

    if (targetLink.startsWith('http://') || targetLink.startsWith('https://')) {
      window.open(targetLink, '_blank')
      return
    }
    if (targetLink.startsWith('schema://')) {
      // 可扩展schema处理
      return
    }
    customNavigator(targetLink)
  }

  // 新系统消息渲染
  if (isNewSystemMsg && newSystemMsgContentData) {
    return (
      <div
        className={`MessageItem ${self ? 'MessageItemSelf' : ''}`}
        id={String(data?.created_at)}
      >
        {showTime ? (
          <div style={{ textAlign: 'center', color: 'white' }}>
            {dayjs(Number(data?.created_at) * 1000).format(
              'YYYY-MM-DD HH:mm:ss'
            )}
          </div>
        ) : null}
        {/* 名称 */}
        {nickname && <div className="message-name">{nickname}</div>}
        <div className="message-line">
          {/* 消息 */}
          <div
            className={`message-box ${
              blackBgMsg.includes(type as MessageEnum)
                ? 'message-box-black'
                : ''
            }`}
            onClick={() => {
              if (config?.url) {
                window.location.href = config?.url as string
              }
            }}
          >
            <div
              className="message-text"
              dangerouslySetInnerHTML={{
                __html: newSystemMsgContentData.content.replaceAll(
                  '\n',
                  '<br />'
                )
              }}
            />
          </div>
          {/* 只渲染第一个按钮，样式与老代码一致 */}
          {newSystemMsgContentData?.extra?.button &&
            newSystemMsgContentData.extra.button.length > 0 &&
            handleShowJumpLinkBtn(newSystemMsgContentData.extra.button[0]) && (
              <span
                style={{ cursor: 'pointer' }}
                className="btn-tag"
                onClick={() =>
                  handleJumpTo(
                    newSystemMsgContentData.extra.button[0]?.link || ''
                  )
                }
              >
                {newSystemMsgContentData.extra.button[0].text}
              </span>
            )}
        </div>
      </div>
    )
  }

  return (
    <div
      className={`MessageItem ${self ? 'MessageItemSelf' : ''}`}
      id={String(data?.created_at)}
    >
      {showTime ? (
        <div style={{ textAlign: 'center', color: 'white' }}>
          {dayjs(Number(data?.created_at) * 1000).format('YYYY-MM-DD HH:mm:ss')}
        </div>
      ) : null}
      {/* 名称 */}
      {nickname && <div className="message-name">{nickname}</div>}
      <div className="message-line">
        {/* 消息 */}
        <div
          className={`message-box ${
            blackBgMsg.includes(type as MessageEnum) ? 'message-box-black' : ''
          }`}
          onClick={() => {
            if (config?.url) {
              window.location.href = config?.url as string
            }
          }}
        >
          {/* 文本消息 */}
          {[MessageEnum.Text, MessageEnum.System].includes(
            type as unknown as MessageEnum
          ) ? (
            <div
              className="message-text"
              dangerouslySetInnerHTML={{
                __html: contentData || ''
              }}
            ></div>
          ) : null}

          {/* 图片消息 */}
          {type === MessageEnum.Image && (
            <div className="message-media">
              <Image src={data?.message_content as string} width={185} />
            </div>
          )}

          {/* 讨论消息 */}
          {type === MessageEnum.Discuss && (
            <div
              className={`message-media ${styles.messageDiscuss}`}
              onClick={handleRead}
            >
              <div className="">
                <Discuss config={config} info={extra as IStoryListItem} />
              </div>
            </div>
          )}

          {/* 故事消息 */}
          {type === MessageEnum.Story && (
            <div
              className={`message-media ${styles.messageStory}`}
              onClick={handleRead}
            >
              <div className="">
                <Story info={extra as IStoryListItem} />
              </div>
            </div>
          )}

          {/* 视频消息 */}
          {type === MessageEnum.Video && (
            <div
              className={`message-media ${styles.messageVideo}`}
              onClick={handleRead}
            >
              <div className="">
                <VideoItem info={extra as IListRellItem} />
              </div>
            </div>
          )}

          {/* 书单消息 */}
          {type === MessageEnum.Books && (
            <div
              className={`message-media ${styles.messageBooks}`}
              onClick={handleRead}
            >
              <div className="">
                <Books info={extra as IStoryListItem} />
              </div>
            </div>
          )}

          {/* 回复消息 */}
          {type === MessageEnum.Reply && (
            <div className="message-reply">
              <Personal size={'small'} userData={{}} />
              <div className="c-white ml20">
                &quot;Gran trabajo, cohesionado a la perfección yun concepto
                gráfico muy interesante.&quot;
              </div>
            </div>
          )}
        </div>

        {(data?.message_content as IMessageContentExtra)?.extra
          ?.notification_type &&
        (data?.message_content as IMessageContentExtra)?.extra?.link &&
        !MessageFilterJumpURL.includes(
          (data?.message_content as IMessageContentExtra)?.extra?.link?.split(
            '?'
          )[0]
        ) ? (
          <span
            style={{ cursor: 'pointer' }}
            className="btn-tag"
            onClick={() => {
              handleJumpTo(
                (data?.message_content as IMessageContentExtra)?.extra?.link ||
                  ''
              )
            }}
          >
            {
              (data?.message_content as IMessageContentExtra)?.extra
                ?.button_name
            }
          </span>
        ) : null}
      </div>
    </div>
  )
}

export const MessageTime = ({ time }: { time: string }) => {
  return (
    <div className="MessageTime">
      <span>{time}</span>
    </div>
  )
}
